/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
:global(.rdp-root) {
  --rdp-accent-color: var(--color-primary-500);
  --rdp-background-color: rgb(245 245 245);
  --rdp-outline: 2px solid var(--color-primary-500);
  --rdp-outline-selected: 2px solid rgba(0, 0, 0, 0.75);
  --rdp-nav_button-height: 1.75rem;
  --rdp-nav_button-width: 1.75rem;
}
:global(.rdp-day) {
  border-radius: var(--radius-sm, 0.25rem);
}
:global(button.rdp-selected) {
  background-color: var(--color-primary-500);
}
:global(.rdp-month_caption) {
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  text-transform: capitalize;
  --tw-font-weight: var(--font-weight-normal, 400);
  font-weight: var(--font-weight-normal, 400);
  color: var(--color-emphasis-high, #000);
  margin-left: calc(var(--spacing, 0.25rem) * 3);
}
.label {
  display: block;
  position: relative;
  width: 100%;
  background-color: transparent;
  min-width: calc(var(--spacing, 0.25rem) * 32);
}
:global(.rdp-selected .rdp-day_button) {
  background-color: var(--color-primary-100);
}
:global(.rdp-today) {
  --tw-font-weight: var(--font-weight-bold, 700);
  font-weight: var(--font-weight-bold, 700);
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-font-weight: initial;
    }
  }
}
